import Config from '../configs/config';
import diff from 'virtual-dom/diff';
import patch from 'virtual-dom/patch';
import createElement from 'virtual-dom/create-element';
import VNode from 'virtual-dom/vnode/vnode';
import VText from 'virtual-dom/vnode/vtext';
import htmlToVdom from 'html-to-vdom';
import { accountMobileNavUtil } from '../../../core/js/utils/accountMobileNavUtils';

let convertHTML = htmlToVdom({
    VNode: VNode,
    VText: VText
});

let tree = '',
    newTree = '',
    patches = '',
    latched = false,
    rootNode;

export function updateView(state)  {
    return new Promise(function(resolve, reject) {
        if(tree != '' && !Config.defaults.fullReset){
            newTree = convertHTML(state.trim());
            patches = diff(tree, newTree);
            rootNode = patch(rootNode, patches);
            tree = newTree;
        } else {
            tree = convertHTML(state.trim());
            rootNode = createElement(tree);
            jQuery('#account-container').replaceWith(rootNode);

            Config.defaults.fullReset = false;
        }

        resolve(rootNode);
    });
}

export function updateHeader(hState)  {
    return new Promise(function(resolve, reject) {
        const hTree = convertHTML(hState.trim());
        const hRootNode = createElement(hTree);
        jQuery('.js-account-navigation').replaceWith(hRootNode);
        accountMobileNavUtil(__store.getState());

        resolve(hRootNode);
    })
}
